class AppUrl {
	static baseurl = "https://app.adspin.org/"
    //static baseurl = 'http://127.0.0.1:8000/'
    static photoUrl = this.baseurl //this.baseurl+'static/images/';

}

export default AppUrl